// Portal role → recon role mapping. The portal is the authoritative role
// registry; recon derives its own permission level from the portal's claim so
// we don't have to maintain two roster sources of truth.
//
// Mapping (kept in sync with the portal-bridge patch in v2.9 gate.js):
//   isAdmin / role === 'admin'   -> 'admin'
//   role === 'editor'            -> 'service-manager'
//   role === 'viewer' (default)  -> 'technician'
export function reconRoleFromClaims(claims = {}) {
  if (claims.isAdmin || claims.role === 'admin') return 'admin';
  if (claims.role === 'editor') return 'service-manager';
  return 'technician';
}

const RANK = { technician: 1, 'service-manager': 2, admin: 3 };

// Returns true if `actual` meets or exceeds the required role rank.
export function hasRole(actual, required) {
  return (RANK[actual] || 0) >= (RANK[required] || 0);
}

// Role-appropriate landing page. Technicians live exclusively in the
// inspection workspace — they don't need the pipeline board, admin,
// or vehicle detail screens. Service managers and admins land on the
// pipeline by default.
export function homeForRole(role) {
  return role === 'technician' ? '/inspect' : '/';
}

// True if this role should ever see the Pipeline / Vehicle / Admin
// surfaces. Technicians never do — keeps the UI honest about their scope.
export function canAccessPipeline(role) {
  return hasRole(role, 'service-manager');
}
